module.exports = "<events-page></events-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/events.html
// module id = 1907
// module chunks = 0